export default __webpack_public_path__ + "static/media/bt4dg.636a9c04.png";